import React from 'react';
import YesNoFilter from './YesNoFilter';

export default function CreditNoteSentFilter({ placeholder = 'Sent', name, value, onChange }) {
  return (
    <YesNoFilter icon="filter" clearable placeholder={placeholder} name={name} value={value} onChange={onChange} />
  );
}
